import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const enterpriseAlexaSkillImporterSelectors = importerSelectors(
  'enterpriseAlexaSkill.importer',
);

export default enterpriseAlexaSkillImporterSelectors;
